export class FileModel {
    id: number = 0;
    originalName: string = "";
    storeName: string = "";
    mimeType: string = "";
    sizeInBytes: number = 0;
    type: number = 0;
    url: string = "";
    upLoadDate: Date = new Date
    upLoadBy: string = "";
    pageNumber: number = 0;
    pageStart: number = 0;
    pageEnd: number = 0;
    extension: string = '';
    isGaruda: boolean = false
    getFileSizeInKB() {
        return this.sizeInBytes / 1000;
    }
}




